import { CarrierVisitsApi } from '@operations/app/api'
import { CarrierVisitRefreshEventPayload } from '@operations/app/api/signalRDtos/carrierVisitRefreshEventPayload'
import { CarrierVisitWorkInstructionUpsertedPayload } from '@operations/app/api/signalRDtos/carrierVisitWorkInstructionUpsertedPayload'
import { createApiClient } from '@operations/app/http-client'
import { EventTypes } from '@operations/messages/eventsTypes'
import { IEvent, MessageBus } from '@tom-ui/utils'
import { action, makeObservable, observable, runInAction } from 'mobx'

export class IsCraneSplitOutdatedUIStore {
  vesselVisitId?: number
  isCraneSplitOutDated = false

  constructor(private readonly messageBus: MessageBus) {
    makeObservable(this, {
      vesselVisitId: observable,
      isCraneSplitOutDated: observable,
      setVesselVisitId: action,
    })

    this.messageBus.subscribeEvent<CarrierVisitWorkInstructionUpsertedPayload>(
      EventTypes.CarrierVisitWorkInstructionUpserted,
      this.handleWorkInstructionUpsertedEvent,
    )

    this.messageBus.subscribeEvent<CarrierVisitRefreshEventPayload>(
      EventTypes.CarrierVisitRefresh,
      this.handleCarrierVisitRefreshEvent,
    )

    this.messageBus.subscribeEvent<number>(
      EventTypes.CraneSplitGeneratedForVisit,
      this.handleCraneSplitGeneratedForVisitEvent,
    )
  }

  public setVesselVisitId(vesselVisitId?: number) {
    this.vesselVisitId = vesselVisitId
  }

  private readonly handleWorkInstructionUpsertedEvent = async (
    event: IEvent<CarrierVisitWorkInstructionUpsertedPayload>,
  ) => {
    const payload = event.payload

    if (payload?.carrierVisitId === this.vesselVisitId && payload?.carrierVisitId) {
      await this.getIfCraneSplitOutDated(payload.carrierVisitId)
    }
  }

  private readonly handleCarrierVisitRefreshEvent = async (
    event: IEvent<CarrierVisitRefreshEventPayload>,
  ) => {
    const payload = event.payload

    if (payload?.carrierVisits?.some(cv => cv.carrierVisitId === this.vesselVisitId)) {
      await this.getIfCraneSplitOutDated(this.vesselVisitId!)
    }
  }

  private readonly handleCraneSplitGeneratedForVisitEvent = (event: IEvent<number>) => {
    const visitId = event.payload

    if (this.vesselVisitId === visitId) {
      runInAction(() => {
        this.isCraneSplitOutDated = false
      })
    }
  }

  public async load(carrierVisitId: number) {
    if (carrierVisitId === this.vesselVisitId) return
    this.setVesselVisitId(carrierVisitId)
    await this.getIfCraneSplitOutDated(carrierVisitId)
  }

  private async getIfCraneSplitOutDated(carrierVisitId: number) {
    const { data } = await createApiClient(CarrierVisitsApi).getIsCraneSplitOutDated(carrierVisitId)

    runInAction(() => {
      this.isCraneSplitOutDated = data
    })
  }
}
